


























































import Vue from 'vue'
import helpers from '../../helpers'
import { WebRTCEncoderSettings } from '@/types/users'
import { Select, Option } from 'element-ui'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import { between, minLength, required } from 'vuelidate/lib/validators'
import { Feature } from '@/featureFlags/featureFlags'

interface SelectionOption {
  name: string,
  value: string
}

export default Vue.extend({
  name: 'EditUserEncoderSettings',
  data: () => ({
    resolutionLabel: '360'
  }),
  props: {
    value: {
      type: Object as () => WebRTCEncoderSettings,
      required: true
    }
  },
  validations: {
    videoBitrate: {
      required,
      minLength: minLength(3),
      between (value: number) {
        if (value < 200) return false
        if (value > this.maxVideoBitrate) return false
        return true
      }
    },
    audioBitrate: {
      required,
      minLength: minLength(2),
      between: between(16,256)
    }
  },
  created () {
    if (this.value) {
      this.audioBitrate = '' + this.value.audioBitrate ?? 32
      this.videoBitrate = '' + this.value.videoBitrate ?? 320
    }
  },
  mounted () {
    this.resolution = '' + (this.value?.height ?? this.defaultHeight)
  },
  computed: {
    maxVideoBitrate (): number {
      return this.$hasFeature(Feature.HIGH_QUALITY_CASTERS) ? 10000 : 2000
    },
    resolutionOptions (): SelectionOption[] {
      const options: SelectionOption[] = []
      if (this.$hasFeature(Feature.HIGH_QUALITY_CASTERS)) options.push({ name: '1080p', value: '1080' })
      options.push({ name: '720p', value: '720' })
      options.push({ name: '360p', value: '360' })
      return options
    },
    defaultHeight (): number {
      return 360
    },
    resolution: {
      get (): string {
        return this.resolutionLabel
      },
      set (value: string) {
        this.resolutionLabel = value
        this.$set(this.value, 'height', parseInt(value))
        const width = (this.value?.height ?? this.defaultHeight) * 16 / 9
        this.$set(this.value, 'width', width)
      }
    },
    audioBitrate: {
      get (): string {
        return '' + (this.value.audioBitrate ?? 32)
      },
      set (value: string) {
        const sanitizedValue = parseInt(value as string, 10)
        this.$v.$touch()
        if (isNaN(sanitizedValue)) {
          return
        }
        this.$set(this.value, 'audioBitrate', sanitizedValue)
      }
    },
    videoBitrate: {
      get (): string {
        return '' + (this.value.videoBitrate ?? 320)
      },
      set (value: string) {
        const sanitizedValue = parseInt(value as string, 10)
        this.$v.$touch()
        if (isNaN(sanitizedValue)) {
          return
        }
        this.$set(this.value, 'videoBitrate', sanitizedValue)
      }
    },
    isMac (): boolean {
      return helpers.isMac()
    },
    canEditCast (): boolean {
      return this.$can(AbilityAction.Edit, AbilitySubject.Cast)
    },
  },
  methods: {
    // handle case where user: double clicks value / deletes it / leaves field
    videoBitRateBlurred (o) {
      if (!o) {
        this.videoBitrate = '0'
      }
    },
    audioBitRateBlurred (o) {
      if (!o) {
        this.audioBitrate = '0'
      }
    }
  },
  components: {
    'el-select': Select,
    'el-option': Option
  }
})
